<template>
  <div class="column is-3">
    <aside class="menu">
      <p class="menu-label">
        General
      </p>
      <ul class="menu-list">
        <li><a :class="isActive('dashboard')" @click="changeView('dashboard')">Dashboard</a></li>
      </ul>
      <p class="menu-label">
        Conditioner
      </p>
      <ul class="menu-list">
        <li><a :class="isActive('create')" @click="changeView('create')">Create PDF</a></li>
        <li><a :class="isActive('exercises')" @click="changeView('exercises')">Exercises</a></li>
        <li><a :class="isActive('gymnasts')" @click="changeView('gymnasts')">Gymnasts</a></li>
      </ul>
    </aside>
  </div>
</template>

<script>

export default {
  name: 'SideMenu',
  props: {
    view: String
  },
  methods: {
    changeView (view) {
      this.$emit('update:view', view)
      this.$router.push('/home/' + view)
    },
    isActive (view) {
      if(view === this.view) {
        return 'is-active'
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SideMenu.vue